import React from "react";
import { Truck, Wrench, Warehouse, Settings, Sparkles, Recycle, ArrowUpRight } from "lucide-react";

const SERVICES = [
  {
    id: "remorquage",
    icon: Truck,
    title: "Remorquage",
    desc: "Tout véhicule, partout. Remorquage rapide et sécurisé vers le garage de votre choix ou à l'adresse souhaitée.",
  },
  {
    id: "depannage",
    icon: Wrench,
    title: "Dépannage",
    desc: "Panne mécanique, batterie, crevaison, panne de carburant — diagnostic et réparation sur place quand c'est possible.",
  },
  {
    id: "gardiennage",
    icon: Warehouse,
    title: "Gardiennage",
    desc: "Stockage et gardiennage sécurisé de votre véhicule en attendant réparation, expertise ou enlèvement.",
  },
  {
    id: "entretien",
    icon: Settings,
    title: "Petit entretien",
    desc: "Vidange, plaquettes, ampoules, batterie… Petit entretien rapide réalisé avec soin et au juste prix.",
  },
  {
    id: "nettoyage",
    icon: Sparkles,
    title: "Nettoyage auto",
    desc: "Lavage extérieur, nettoyage intérieur, désinfection. Votre voiture comme neuve, dans les règles de l'art.",
  },
  {
    id: "vhu",
    icon: Recycle,
    title: "Récupération VHU",
    desc: "Véhicules hors d'usage : enlèvement gratuit avec remise du certificat de destruction conformément à la réglementation.",
  },
];

export const Services = () => {
  return (
    <section id="services" className="relative py-24 sm:py-32 bg-[#0A0A0A]" data-testid="services-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mb-14">
          <div className="text-[#FFD600] text-xs font-bold tracking-[0.3em] uppercase mb-3">
            — Nos prestations
          </div>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl text-white uppercase tracking-tight">
            Tout pour <span className="text-[#FFD600]">votre véhicule</span>,<br />
            sous un seul numéro.
          </h2>
          <p className="mt-5 text-neutral-400 text-lg max-w-2xl">
            Six services complémentaires pour vous sortir d'embarras et entretenir votre véhicule au quotidien.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {SERVICES.map((s, idx) => {
            const Icon = s.icon;
            return (
              <div
                key={s.id}
                data-testid={`service-card-${s.id}`}
                className="group relative bg-[#171717] border border-[#262626] rounded-lg p-7 hover:border-[#FFD600]/50 hover:-translate-y-1 transition-all duration-300 overflow-hidden"
              >
                <div className="absolute -top-12 -right-12 w-32 h-32 bg-[#FFD600]/0 group-hover:bg-[#FFD600]/5 rounded-full blur-2xl transition-all duration-500" />
                <div className="relative">
                  <div className="flex items-start justify-between mb-6">
                    <div className="h-12 w-12 rounded-md bg-[#FFD600]/10 border border-[#FFD600]/30 flex items-center justify-center group-hover:bg-[#FFD600] transition-colors">
                      <Icon className="w-6 h-6 text-[#FFD600] group-hover:text-[#0A0A0A]" strokeWidth={2} />
                    </div>
                    <span className="font-display text-neutral-700 text-2xl">
                      0{idx + 1}
                    </span>
                  </div>
                  <h3 className="font-display text-2xl text-white uppercase tracking-tight mb-3 flex items-center gap-2">
                    {s.title}
                    <ArrowUpRight className="w-4 h-4 text-[#FFD600] opacity-0 group-hover:opacity-100 transition-opacity" />
                  </h3>
                  <p className="text-neutral-400 text-sm leading-relaxed">{s.desc}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
